import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(form.email, form.password);
      toast.success(`Selamat datang, ${u.name}`);
      navigate(u.role === "admin" ? "/admin" : "/talent-dashboard");
    } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="eyebrow mb-3">Masuk</p>
      <h1 className="text-3xl sm:text-4xl tracking-tight font-medium text-slate-800">Talent & Admin</h1>
      <p className="mt-3 text-slate-600 leading-relaxed">User tidak perlu akun. Halaman ini untuk talent dan admin Sudut Nadi.</p>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
        <input className="input-soft" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" required />
        <input className="input-soft" type="password" placeholder="Kata sandi" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" required />
        {error && <p className="text-sm text-rose-700" data-testid="login-error">{error}</p>}
        <button className="btn-primary w-full" disabled={loading} data-testid="login-submit-button">{loading ? "Memproses..." : "Masuk"}</button>
      </form>
    </div>
  );
}
